import React from 'react';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';
import ICellProps, { ITranchRow } from './ICellProps';
import { formatDataCell } from '@/creditflowresearch/ui/components/deals/helpers';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getCell = ({ row: tranche }: ITranchRow) => formatDataCell(tranche.spread);

const SpreadCell = ({
  rowIndex,
  tranche,
}: ICellProps) => (
  <BodyCell
    name="SpreadCell"
    className={ alignStyles.alignRight }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default SpreadCell;
